import React, { useState } from 'react'
import TWControls from 'components/controls/TWControls'
import { Form } from 'components/controls/useForm'
import { Checkbox } from 'components/ui/checkbox'

const BulkLocationsAddPopup = ({ handlePostBulkLocations, locationCount }) => {
	const [active, setActive] = useState(true)

	const submitHandler = e => {
		handlePostBulkLocations(active)
	}

	const handleActiveChange = checked => {
		setActive(checked)
	}

	return (
		<Form className="min-w-[360px] m-1" onSubmit={submitHandler}>
			<div className="grid grid-cols-12 gap-4">
				<div className="col-span-12">
					<p className="flex items-center justify-center">
						{`Posting ${locationCount} new locations to your Locations Catalogue.`}{' '}
					</p>
					<p className="flex items-center justify-center">
						{`By default all locations will be uploaded with the status of:`}{' '}
					</p>
					<div className="flex items-center justify-center pt-8">
						<label className="flex items-center gap-2 cursor-pointer">
							<Checkbox
								checked={active}
								onCheckedChange={handleActiveChange}
							/>
							<span className="text-sm">{active ? 'Active' : 'In Active'}</span>
						</label>
					</div>
				</div>
				<div className="col-span-12">
					<div className="flex items-center justify-center pt-4">
						<TWControls.Button size="small" type="submit" text="Post" />
					</div>
				</div>
			</div>
		</Form>
	)
}

export default BulkLocationsAddPopup
